import { render, staticRenderFns } from "./MoveItemTo.vue?vue&type=template&id=6d342b6b&scoped=true"
import script from "./MoveItemTo.vue?vue&type=script&lang=js"
export * from "./MoveItemTo.vue?vue&type=script&lang=js"
import style0 from "./MoveItemTo.vue?vue&type=style&index=0&id=6d342b6b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d342b6b",
  null
  
)

export default component.exports